import '../../../../../styles.scss';
import React, { useEffect } from 'react';
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import SniffToast, { toasterDanger } from '../../utils/sniff-toast';
import { ASSET_PATH } from '../../../../consts/env.consts';
import useMutateTrackEvent from '../../../../services/hooks/useMutateTrackEvent';
import { setFirstClick } from '../../../../helpers/firstClick';
import RevisedSsr from '../../../../pages/home/home-revised';
import { loadFirebaseAfterPageLoad } from '../../../../helpers/load-firebase';

// eslint-disable-next-line no-undef
__webpack_public_path__ = ASSET_PATH;

const client = new ApolloClient({
    link: new HttpLink({ uri: '/graphql' }),
    cache: new InMemoryCache(),
});

const HomeRevised = (props) => {
    useEffect(() => {
        setFirstClick();
        loadFirebaseAfterPageLoad();
    }, []);

    return (
        <ApolloProvider client={client}>
            <SniffToast />
            <RevisedSsr
                {...{
                    ...props,
                    useMutateTrackEvent,
                    toasterDanger,
                    SSR: true,
                }}
            />
        </ApolloProvider>
    );
};

export default HomeRevised;
